import { render, staticRenderFns } from "./RiskProfileWidget.vue?vue&type=template&id=421dcff6&"
import script from "./RiskProfileWidget.vue?vue&type=script&lang=ts&"
export * from "./RiskProfileWidget.vue?vue&type=script&lang=ts&"
import style0 from "./RiskProfileWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports